export default "__VITE_ASSET__CqHVrtT4__"